import { z } from "zod";

export const getProjectTimelineNoteSchema = z.object({
	projectId: z.string().uuid(),
	noteId: z.string().uuid(),
});

export type GetProjectTimelineNoteSchema = z.infer<typeof getProjectTimelineNoteSchema>;
